import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";

const client = new ApiClient(client_core)

const endpoints = {
    setup: '/dashboard/v2/events/setup/', // POST
    create_config: '/dashboard/v2/events/create_config/', // GET
    categories: '/dashboard/v2/events/regions/{region}/categories/', // GET
    contracts: '/dashboard/v2/events/contracts/', // GET
    contract: '/dashboard/v2/events/contracts/{id}/', // GET
}

export default {
    async createNewEvent(data) {
        return await client.post(endpoints.setup, data)
    },
    async fetchCreateConfig({region, plan, category}, contractId = null) {
        let params = {}
        if (region && region.length > 0) params.region = region
        if (plan && plan.length > 0) params.plan = plan
        if (category && category.length > 0) params.category = category
        if (contractId) params.contract_id = contractId
        return await client.get(endpoints.create_config, params)
    },
    async fetchCategories(region) {
        return await client.get(endpoints.categories.replace('{region}', region))
    },
    async fetchContracts() {
        return await client.get(endpoints.contracts)
    },
    async fetchContract(id) {
        return await client.get(endpoints.contract.replace('{id}', id))
    }
}

